import Breadcrumbs from "@mui/material/Breadcrumbs";
import { generatePath, Link as RouterLink, useParams } from "react-router-dom";
import Link from "@mui/material/Link";
import { useCrumbs } from "./CrumbContext";
import { useMemo } from "react";
const safeGenPath = (path, params) => {
  if (!path) {
    return null;
  }
  try {
    return generatePath(path, params);
  } catch (err) {
    return null;
  }
};
export const BreadcrumbContainer = ({ sx = {} }) => {
  const { crumbs } = useCrumbs();
  const params = useParams();
  const crumbsMapped = useMemo(() => {
    return crumbs.map((crumb) => {
      return {
        ...crumb,
        data: {
          ...crumb.data,
          to: safeGenPath(crumb.data.to, params),
        },
      };
    });
  }, [crumbs, params]);
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ ...sx }}>
      {crumbsMapped.map(({ id, data: { text, Component, to } }) => (
        <Link
          key={id}
          underline={to ? "always" : "none"}
          color="inherit"
          to={to}
          component={to ? RouterLink : undefined}
        >
          {Component ? <Component /> : text}
        </Link>
      ))}
    </Breadcrumbs>
  );
};
